// extracted by mini-css-extract-plugin
export default {"rankingRow":"Ranking_rankingRow__BtgPK"};